import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MapPropTypes from '../../MapPropTypes';
import Label from './Label';

export default class ContinuousWeekly extends Component {
    static propTypes = {
        maxMonths: PropTypes.number.isRequired, // unused
        maxWeeks: PropTypes.number.isRequired,
        monthCount: PropTypes.number.isRequired, // unused
        onBlur: PropTypes.func.isRequired,
        prices: MapPropTypes.PricingProps.isRequired, // unused
        showWeeks: PropTypes.bool,
        updateMonthCount: PropTypes.func.isRequired, // unused
        updateWeekCount: PropTypes.func,
        weekCount: PropTypes.number,
    };

    constructor(props) {
        super(props);
    }

    _renderWeekInput() {
        return (
            <div>
                <input
                    value={this.props.weekCount || 1}
                    onChange={(e) =>
                        this.props.updateWeekCount(parseInt(e.target.value, 10))
                    }
                    onBlur={() => this.props.onBlur()}
                    type="number"
                    className="form-control m-l-xs"
                    step="1"
                    min="1"
                    max={this.props.maxWeeks}
                />
                <Label s="weeks" />
            </div>
        );
    }

    render() {
        return (
            <div className="row m-a-0">
                {this.props.showWeeks && (
                    <div className="p-a-0 col-xs-12">
                        {this._renderWeekInput()}
                    </div>
                )}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./app/components/Cart/DurationInput/ContinuousWeekly.jsx